import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: auto;\n    display: inline-block;\n    &::after {\n      right: -25px;\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    &::after {\n      right: 0;\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 14px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-left: 15px;\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 18px;\n  color: ", ";\n  & > span {\n    line-height: 24px;\n  }\n  &::after {\n    content: \"\";\n    display: ", ";\n    position: absolute;\n    height: 7px;\n    width: 10px;\n    right: -50px;\n    top: 35%;\n    border-style: solid;\n    border-width: 2px;\n    border-color: transparent transparent ", " ", ";\n    transform: translate(0, -50%) rotate(-50deg);\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin-top: 24px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex !important;\n  width: 100%;\n  cursor: pointer;\n  &:not(:first-child) {\n    margin-top: 33px;\n    ", "\n  }\n  img {\n    min-width: 26px;\n    min-height: 26px;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    transition: all 0.2s ease-in-out;\n  }\n  &:hover {\n    img {\n      border: 2px solid #ecedee;\n      transition: all 0.2s ease-in-out;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { baseFontColor, red, thinFontFamily } from "@temp/@next/globalStyles/constants";
export var Wrapper = styled.ul(_templateObject());
export var Item = styled.li(_templateObject2(), media.xxLargeScreen(_templateObject3()));
export var ItemLabel = styled.div(_templateObject4(), thinFontFamily, function (props) {
  return props.active ? baseFontColor : "rgba(44, 44, 44, 0.7)";
}, function (props) {
  return props.active ? "block" : "none";
}, red, red, media.xxLargeScreen(_templateObject5()), media.mediumScreen(_templateObject6()), media.smallScreen(_templateObject7()));